export const QUESTIONS_ONBOARDING_COOKIE_KEY = 'questions_feature_onboarding_counter';
export const QUESTIONS_ONBOARDING_CONFIG_KEY = 'newbuildingQuestionsOnboarding.Enabled';
export const QUESTIONS_CONFIG_KEY = 'newbuildingQuestions.Enabled';

export const MAX_DISPLAY_QUESTIONS_ONBOARDING_COUNT = 3;
